import { render, staticRenderFns } from "./designs.vue?vue&type=template&id=234ba264"
import script from "./designs.vue?vue&type=script&lang=js"
export * from "./designs.vue?vue&type=script&lang=js"
import style0 from "./designs.vue?vue&type=style&index=0&id=234ba264&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports